/** Id del landmark `<main>` del layout que actúa como shell de la página. Lo reutilizan el skip link (TAN-8654) y MS3. */
export const MAIN_CONTENT_ID = 'main-content';
